import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from '../imagenes/logoutm.png'
import ListarTipoPublicaciones from "../componentes/ListarTipoPublicaciones";

const TipoPublicaciones = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                        <title>Tipo de Publicaciones - Sistema de Administración Museo UTM</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <ListarTipoPublicaciones />
        </>
    );
}

export default TipoPublicaciones;